import { useState } from "react";

const tagData = [
  { name: "吃瓜前线", count: 386 },
  { name: "直播热点", count: 274 },
  { name: "剧组风云", count: 248 },
  { name: "综艺观察", count: 231 },
  { name: "影视前瞻", count: 205 },
  { name: "感情线", count: 198 },
  { name: "造型图鉴", count: 186 },
  { name: "现场直击", count: 172 },
  { name: "合约风波", count: 158 },
  { name: "澄清专区", count: 144 },
  { name: "音乐现场", count: 132 },
  { name: "品牌代言", count: 118 },
  { name: "红毯图鉴", count: 104 },
  { name: "社交动态", count: 92 },
];

export default function TagTower() {
  const [activeTag, setActiveTag] = useState("吃瓜前线");
  const activeCount = tagData.find((t) => t.name === activeTag)?.count ?? 0;

  return (
    <section id="tags" className="bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.75fr_1.25fr] lg:gap-14">
          <div>
            <div className="mb-3 flex items-center gap-3">
              <span className="font-heading text-sm font-bold text-primary-500">04</span>
              <span className="h-px w-8 bg-primary-300" />
              <span className="text-xs font-medium tracking-[0.22em] text-secondary-600">
                Tag Tower
              </span>
            </div>
            <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-[32px]">
              标签塔 · 按话题方向逛
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              标签是全站最细的导航单位。点一个方向，就能筛出所有归到该标签下的条目，热度越高的方向，条目堆得越密。
            </p>
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <p className="text-xs font-medium text-foreground-500">当前选中</p>
              <p className="mt-1.5 font-heading text-xl font-bold text-primary-600">{activeTag}</p>
              <p className="mt-1 text-sm text-foreground-600">
                共收录 <span className="font-semibold text-foreground-900">{activeCount}</span> 条相关条目
              </p>
            </div>
          </div>

          <div className="flex flex-wrap content-start gap-2.5 md:gap-3">
            {tagData.map((tag, idx) => (
              <button
                key={tag.name}
                type="button"
                onClick={() => setActiveTag(tag.name)}
                className={`flex cursor-pointer items-center gap-2 rounded-full border px-4 py-2.5 text-sm font-medium transition-colors ${
                  activeTag === tag.name
                    ? "border-primary-300 bg-primary-500 text-background-50"
                    : "border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
                }`}
              >
                {tag.name}
                <span
                  className={`rounded-full px-1.5 py-0.5 text-[11px] ${
                    activeTag === tag.name
                      ? "bg-background-50/25 text-background-50"
                      : idx % 3 === 0
                        ? "bg-accent-100 text-accent-900"
                        : "bg-secondary-100 text-secondary-800"
                  }`}
                >
                  {tag.count}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}